import { vars } from '@repo/config';
import type { ILinkTelegramRequest } from './link-telegram-request';
import type { ILinkTelegramResponse } from './link-telegram-response';

export async function linkTelegramApi(body: ILinkTelegramRequest): Promise<ILinkTelegramResponse> {
  const url = new URL('/telegram/link', vars.url.identityUrl);

  const response = await fetch(url.toString(), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  } as RequestInit);

  if (!response.ok) {
    throw new Error(`Telegram link failed: ${response.status}`);
  }

  return response.json() as Promise<ILinkTelegramResponse>;
}
